import { useEffect } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { GestureDetector, Gesture } from "react-native-gesture-handler";
import Animated, {
  Easing,
  Extrapolate,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import Story from "./Story";

// Data
import { useDispatch, useSelector } from "react-redux";
import { selectStories, setViewingStory } from "../../redux/mainSlice";

// Utils
import { Colors } from "../../styles";
import { nanoid } from "@reduxjs/toolkit";

const MAX_DRAG = 150;

const Stories = () => {
  //#region Redux
  const dispatch = useDispatch();
  const stories = useSelector(selectStories);
  const currentStoryIndex = stories.data.findIndex(
    (s) => s.entity === stories.viewing
  );
  //#endregion

  //#region Gesture
  const start = useSharedValue(0);
  const offset = useSharedValue(0);

  // Reset on popup focus
  const resetAnim = () => {
    offset.value = 0;
    start.value = 0;
  };
  useEffect(resetAnim, [stories]);

  const minimise = withTiming(
    300,
    {
      duration: 100,
      easing: Easing.bezier(0.25, 0.1, 0.25, 1),
    },
    () => {
      dispatch(setViewingStory(undefined));
      resetAnim();
    }
  );

  const springBack = withTiming(
    0,
    {
      duration: 250,
      easing: Easing.bezier(0.25, 0.1, 0.25, 1),
    },
    resetAnim
  );

  const gesture = Gesture.Pan()
    .onBegin(resetAnim)
    .onUpdate(
      (e) => (offset.value = Math.min(e.translationY + start.value, MAX_DRAG))
    )
    .onEnd(() => {
      // start.value = offset.value;

      if (offset.value > 100) offset.value = minimise;
      else offset.value = springBack;
    })
    .onFinalize(() => {});
  //#endregion

  //#region Styles
  const innerStylesAnim = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateY: interpolate(
            offset.value,
            [0, 300],
            [0, 300],
            Extrapolate.CLAMP
          ),
        },
        {
          scale: interpolate(
            offset.value,
            [0, MAX_DRAG, 300],
            [1, 0.9, 0.2],
            Extrapolate.CLAMP
          ),
        },
      ],
    };
  });

  const containerStylesAnim = useAnimatedStyle(() => {
    const opacity = interpolate(
      offset.value,
      [0, MAX_DRAG, 300],
      [1, 0.6, 0],
      Extrapolate.CLAMP
    );

    return {
      backgroundColor: `rgba(0,0,0,${opacity})`,
    };
  });
  //#endregion

  if (!stories.viewing) return <></>;

  return (
    <GestureDetector gesture={gesture}>
      <Animated.View style={[styles.container, containerStylesAnim]}>
        <Animated.View style={[styles.inner, innerStylesAnim]}>
          <Story currentStoryIndex={currentStoryIndex} key={nanoid()} />
        </Animated.View>
      </Animated.View>
    </GestureDetector>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "red",
    width: "100%",
    height: "100%",
    position: "absolute",
  },
  inner: { height: "100%", width: "100%", backgroundColor: Colors.plum900 },
  ball: {
    width: 100,
    height: 100,
    borderRadius: 100,
    backgroundColor: "blue",
    alignSelf: "center",
  },
});

export default Stories;
